module.exports = __webpack_public_path__ + "img/edit-file-icon.79c97d6d.svg";